var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "date-block",
        ((_obj = {}), (_obj["date-block--size-" + _vm.size] = _vm.size), _obj),
        { "date-block--interval": _vm.dateEnd },
      ],
    },
    [
      _c("z-icon", {
        staticClass: "date-block__icon",
        attrs: {
          name: "sg-element",
          width: _vm.iconSize,
          height: _vm.iconSize,
        },
      }),
      _vm._v(" "),
      !!this.$slots["before"]
        ? _c(
            "div",
            { staticClass: "date-block__before" },
            [_vm._t("before")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.momentFormatIn && _vm.momentFormatOut
        ? _c("div", { staticClass: "date-block__container" }, [
            _c("div", { staticClass: "date-block__date" }, [
              _c("div", { staticClass: "date-block__date" }, [
                _vm._v(_vm._s(_vm.buildDateString(_vm.date))),
              ]),
              _vm._v(" "),
              _vm.dateEnd
                ? _c("span", { staticClass: "divider" }, [_vm._v("–")])
                : _vm._e(),
              _vm._v(" "),
              _vm.dateEnd
                ? _c("div", { staticClass: "date-block__date" }, [
                    _vm._v(_vm._s(_vm.buildDateString(_vm.dateEnd))),
                  ])
                : _vm._e(),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "date-block__container" },
            [
              _vm.size !== "xl"
                ? [
                    _c(
                      "div",
                      { staticClass: "date-block__date" },
                      [
                        _c("div", { staticClass: "date-block__date-wrapper" }, [
                          _c("div", { staticClass: "date-block__date" }, [
                            _vm._v(
                              _vm._s(_vm._f("momentFilter")(_vm.date, "DD"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "date-block__ym-wrapper" }, [
                            _c("span", { staticClass: "date-block__month" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("momentFilter")(_vm.date, "MMMM")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "date-block__year" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("momentFilter")(_vm.date, "YYYY")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.dateEnd && !_vm.dateEndInCurrentMonthAndYear
                          ? [
                              _c("span", { staticClass: "divider" }, [
                                _vm._v("–"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "date-block__date-wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "date-block__date" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm._f("momentFilter")(
                                              _vm.dateEnd,
                                              "DD"
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-block__ym-wrapper" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "date-block__month date-block__month--end",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm._f("momentFilter")(
                                                  _vm.dateEnd,
                                                  "MMMM"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "date-block__year date-block__year--end",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm._f("momentFilter")(
                                                  _vm.dateEnd,
                                                  "YYYY"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "date-block__date" },
                      [
                        _c("div", { staticClass: "date-block__date" }, [
                          _vm._v(
                            _vm._s(_vm._f("momentFilter")(_vm.date, "DD"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.dateEnd && !_vm.isSameDate
                          ? [
                              _c("span", { staticClass: "divider" }, [
                                _vm._v("–"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "date-block__date" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm._f("momentFilter")(_vm.dateEnd, "DD")
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "date-block__ym-wrapper" }, [
                      _c("div", { staticClass: "date-block__ym-column" }, [
                        _c("span", { staticClass: "date-block__month" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm._f("momentFilter")(_vm.date, "MMMM")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "date-block__year" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm._f("momentFilter")(_vm.date, "YYYY")) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.dateEnd && !_vm.dateEndInCurrentMonthAndYear
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "date-block__ym-column date-block__ym-column--end",
                            },
                            [
                              _c("span", { staticClass: "divider" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "date-block__month date-block__month--end",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("momentFilter")(
                                          _vm.dateEnd,
                                          "MMMM"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "date-block__year date-block__year--end",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("momentFilter")(
                                          _vm.dateEnd,
                                          "YYYY"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
            ],
            2
          ),
      _vm._v(" "),
      !!this.$slots["after"]
        ? _c("div", { staticClass: "date-block__after" }, [_vm._t("after")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }